// Vollea — Login screen (pixel port of mobile)
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";
import { Btn, Logo } from "../components/ui-vollea";
import PasswordInput from "../components/PasswordInput";
import GoogleSignInButton from "../components/GoogleSignInButton";
import { useAuth } from "../contexts/AuthContext";
import { C, SP, R } from "../lib/theme";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    setErr(""); setBusy(true);
    try {
      const u = await login(email.trim(), password);
      navigate(u.role === "super_admin" ? "/admin" : "/dashboard");
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  const label = { color: C.textMuted, fontSize: 11, fontWeight: 600, letterSpacing: 1, marginBottom: 6, marginTop: SP.md, textTransform: "uppercase", display: "block" };
  const input = { width: "100%", background: C.surface, borderRadius: R.md, border: `1px solid ${C.border}`, color: C.text, padding: `0 ${SP.lg}px`, height: 52, fontSize: 15, outline: "none" };

  return (
    <form onSubmit={submit} style={{ minHeight: "100vh", background: C.bg, padding: `${SP.lg}px ${SP.lg}px 40px` }}>
      <button type="button" onClick={() => navigate("/")} data-testid="login-back" style={{ width: 40, height: 40, color: C.text }}>
        <IoChevronBack size={26} />
      </button>
      <div style={{ display: "flex", justifyContent: "center", margin: `${SP.xl}px 0` }}><Logo size={34} /></div>

      <h1 style={{ color: C.text, fontWeight: 700, fontSize: 26, margin: 0 }}>Welcome back</h1>
      <p style={{ color: C.textMuted, fontSize: 14, marginTop: 4, marginBottom: SP.xl }}>Log in to your Vollea account</p>

      <label style={label}>Email</label>
      <input data-testid="login-email-input" style={input} value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="you@email.com" autoComplete="email" />

      <label style={label}>Password</label>
      <PasswordInput
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoComplete="current-password"
        testid="login-password-input"
        toggleTestid="login-password-toggle"
      />

      {err ? <p data-testid="login-error" style={{ color: C.error, marginTop: SP.md, fontSize: 13 }}>{err}</p> : null}

      <div style={{ textAlign: "right", marginTop: SP.md }}>
        <button type="button" onClick={() => navigate("/forgot-password")} data-testid="login-forgot-link" style={{ color: C.lime, fontSize: 13, fontWeight: 600 }}>Forgot password?</button>
      </div>

      <div style={{ height: SP.lg }} />
      <Btn label="LOG IN" loading={busy} onClick={submit} testid="login-submit-button" type="submit" />

      <div style={{ display: "flex", alignItems: "center", gap: SP.md, margin: `${SP.lg}px 0` }}>
        <div style={{ flex: 1, height: 1, background: C.divider }} />
        <span style={{ color: C.textDim, fontSize: 11, fontWeight: 700, letterSpacing: 1.2, textTransform: "uppercase" }}>or</span>
        <div style={{ flex: 1, height: 1, background: C.divider }} />
      </div>
      <GoogleSignInButton testid="login-google-button" label="Continue with Google" />

      <div style={{ marginTop: SP.xl, textAlign: "center" }}>
        <span style={{ color: C.textMuted, fontSize: 14 }}>New here? </span>
        <button type="button" onClick={() => navigate("/register")} data-testid="login-register-link" style={{ color: C.lime, fontSize: 14, fontWeight: 600 }}>Create account</button>
      </div>
    </form>
  );
}
